import type * as Sentry from "@sentry/nextjs";

type SentryInitOptions = NonNullable<Parameters<typeof Sentry.init>[0]>;

// Общие опции клиента и сервера. Возвращают поведение Sentry 8–10,
// которое в Sentry 11 перестало быть поведением по умолчанию.
export const sentryOptions = {
  // Транзакции вместо потоковой отправки спанов: потоковую поддерживает
  // только self-hosted Sentry от 26.4.2, версию нашего сервера не проверяли
  traceLifecycle: "static",
  // Набор собираемых данных как при sendDefaultPii: false (из migration guide 10 → 11).
  // Без этого Sentry 11 собирает cookies, тела запросов и IP пользователя
  dataCollection: {
    userInfo: false,
    cookies: false,
    httpHeaders: {
      request: { deny: ["forwarded", "-ip", "remote-", "via", "-user"] },
      response: { deny: ["forwarded", "-ip", "remote-", "via", "-user"] },
    },
    httpBodies: [],
    urlQueryParams: { deny: ["forwarded", "-ip", "remote-", "via", "-user"] },
    genAI: { inputs: false, outputs: false },
    databaseQueryData: false,
    queues: false,
    graphQL: { document: false, variables: false },
  },
} satisfies SentryInitOptions;
